import { render, staticRenderFns } from "./DoctorAssist.vue?vue&type=template&id=bada88c0&scoped=true"
import script from "./DoctorAssist.vue?vue&type=script&lang=js"
export * from "./DoctorAssist.vue?vue&type=script&lang=js"
import style0 from "./DoctorAssist.vue?vue&type=style&index=0&id=bada88c0&prod&scoped=true&lang=css"
import style1 from "./DoctorAssist.vue?vue&type=style&index=1&id=bada88c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada88c0",
  null
  
)

export default component.exports